import { render, staticRenderFns } from "./ClickLog.vue?vue&type=template&id=3a6e2f24"
import script from "./ClickLog.vue?vue&type=script&lang=js"
export * from "./ClickLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports